/// <amd-module name="VSSUI/Utilities/Dispatch" />
import * as React from "react";

export declare type EventDelegate<T> = (event: React.SyntheticEvent<HTMLElement>, data?: T) => void;

export interface IEventDispatch {
    addEventListener: <T>(eventType: string, callback: EventDelegate<T>) => void;
    dispatchEvent: <T>(event: React.SyntheticEvent<HTMLElement>, data?: T, type?: string) => void;
    removeEventListener: <T>(eventType: string, callback: EventDelegate<T>) => void;
}

export class EventDispatch implements IEventDispatch {
    private listeners: { [eventType: string]: Array<EventDelegate<{}>> } = {};

    public addEventListener<T>(eventType: string, callback: EventDelegate<T>) {
        if (!(eventType in this.listeners)) {
            this.listeners[eventType] = [];
        }
        this.listeners[eventType].push(callback);
    }

    public dispatchEvent<T>(event: React.SyntheticEvent<HTMLElement>, data?: T, type?: string): void {
        const delegates = this.listeners[type || event.type];

        if (delegates) {
            const stack = delegates.slice();
            for (let i = 0, l = stack.length; i < l; i++) {
                stack[i].call(this, event, data);
            }
        }
    }

    public removeEventListener<T>(eventType: string, callback: EventDelegate<T>) {
        if (!(eventType in this.listeners)) {
            return;
        }

        const stack = this.listeners[eventType];
        for (let i = 0, l = stack.length; i < l; i++) {
            if (stack[i] === callback) {
                stack.splice(i, 1);
                return;
            }
        }
    }
}
